class GrlaColorPicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.controller = new AbortController();
    this.trigger = this.querySelector('.grla-all-colors');
    this.trigger.addEventListener('click', () => this.open(), {signal:this.controller.signal});
    this.variantSelects = this.dataset.context === 'product' ? this.closest('variant-selects') : null;
    if (this.variantSelects) {
      this.nativeFieldset = Array.from(this.variantSelects.querySelectorAll('fieldset')).find(field => field.dataset.handle === this.dataset.optionHandle);
      if (this.nativeFieldset) {
        this.nativeFieldset.classList.add('grla-native-color-hidden');
        this.variantSelects.addEventListener('change', () => this.sync(), {signal:this.controller.signal});
        document.addEventListener('product:variant-change', () => this.sync(), {signal:this.controller.signal});
        this.sync();
      }
    }
    const card = this.closest('product-card');
    if (card) card.classList.add('grla-colors-active');
    if (this.variantSelects && this.querySelector('template').content.querySelectorAll('.grla-color-choice').length > 1 && !location.pathname.endsWith('/products/womens-v-neck-lux-pima-wvss')) {
      this.classList.add('grla-inline-vneck');
      this.trigger.hidden = true;
      const label = document.createElement('p');
      label.textContent = 'Choose your color - all ' + this.querySelector('template').content.querySelectorAll('.grla-color-choice').length + ' colors';
      label.style.cssText = 'font-size:14px;font-weight:600;margin:0 0 12px';
      const grid = document.createElement('div');
      grid.className = 'grla-color-grid grla-inline-grid';
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', 'Choose your color');
      grid.append(this.querySelector('template').content.cloneNode(true));
      const update = () => grid.querySelectorAll('.grla-color-choice').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === this.dataset.current)));
      grid.querySelectorAll('.grla-color-choice').forEach(button => button.addEventListener('click', () => { this.select(button); update(); }, {signal:this.controller.signal}));
      this.variantSelects.addEventListener('change', () => { this.sync(); update(); }, {signal:this.controller.signal});
      update();
      const style = document.createElement('style');
      style.textContent = '.grla-inline-vneck .grla-all-colors{display:none!important}.grla-inline-vneck .grla-inline-grid{grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;padding:0;margin-bottom:18px}.grla-inline-vneck .grla-color-name{font-size:11px;padding:7px 2px 0}.grla-inline-vneck .grla-color-photo img{object-fit:contain}.grla-inline-vneck .grla-color-check{width:18px;height:18px;line-height:18px;top:4px;right:4px;font-size:11px}@media(max-width:600px){.grla-inline-vneck .grla-inline-grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}}';
      this.append(style, label, grid);
    }    if (card && card.current_options && typeof card.updateMasterId === 'function') {
      card.current_options[Number(this.dataset.index)] = this.dataset.current;
      card.updateMasterId();
    }
  }
  disconnectedCallback() {
    if (this.controller) this.controller.abort();
    if (this.nativeFieldset) this.nativeFieldset.classList.remove('grla-native-color-hidden');
    if (this.dialog && this.dialog.open) this.dialog.close();
    this.initialized = false;
  }
  sync() {
    if (!this.nativeFieldset) return;
    const selected = this.nativeFieldset.querySelector('input:checked') || this.nativeFieldset.querySelector('select');
    if (!selected) return;
    this.dataset.current = selected.value;
    this.querySelector('.grla-selected-color strong').textContent = selected.value;
  }
  open() {
    this.sync();
    const dialog = document.createElement('dialog');
    this.dialog = dialog;
    dialog.className = 'grla-color-dialog';
    const header = document.createElement('div');
    header.className = 'grla-dialog-header';
    const heading = document.createElement('h2');
    heading.textContent = this.dataset.dialogLabel;
    heading.id = 'grla-color-dialog-heading';
    dialog.setAttribute('aria-labelledby', heading.id);
    const title = document.createElement('p');
    title.textContent = this.dataset.title;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'grla-dialog-close';
    close.textContent = '×';
    close.setAttribute('aria-label', this.dataset.closeLabel);
    close.addEventListener('click', () => dialog.close());
    header.append(heading, title, close);
    const grid = document.createElement('div');
    grid.className = 'grla-color-grid';
    grid.append(this.querySelector('template').content.cloneNode(true));
    grid.querySelectorAll('.grla-color-choice').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.color === this.dataset.current));
      button.addEventListener('click', () => {
        this.select(button);
        dialog.close();
      });
    });
    dialog.append(header, grid);
    document.body.append(dialog);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      dialog.remove();
      this.trigger.focus({preventScroll:true});
    }, {once:true});
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.showModal();
  }
  select(button) {
    this.dataset.current = button.dataset.color;
    this.querySelector('.grla-selected-color strong').textContent = button.dataset.color;
    if (this.nativeFieldset) {
      const input = Array.from(this.nativeFieldset.querySelectorAll('input[type="radio"]')).find(input => input.value === button.dataset.color);
      const select = this.nativeFieldset.querySelector('select');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      } else if (select && select.value !== button.dataset.color) {
        select.value = button.dataset.color;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
      this.sync();
      return;
    }
    const card = this.closest('product-card');
    if (!card) return;
    const image = card.querySelector('.product-primary-image');
    if (image && button.dataset.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.src = button.dataset.image;
      image.alt = this.dataset.title + ' — ' + button.dataset.color;
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
      card.querySelectorAll('.product-card--image-inner > figure:not(.product-card--image-primary)').forEach(figure => figure.hidden = true);
      const nav = card.querySelector('.product-card--nav-container');
      if (nav) nav.hidden = true;
      const slider = card.querySelector('.product-card--image');
      if (slider) slider.scrollTo({left:0,behavior:'instant'});
    }
    card.querySelectorAll('a.product-card-title, a.product-card--image-link').forEach(link => link.href = button.dataset.url);
    if (card.current_options && typeof card.updateMasterId === 'function') {
      card.current_options[Number(this.dataset.index)] = button.dataset.color;
      card.updateMasterId();
    }
  }
}
if (!customElements.get('grla-color-picker')) customElements.define('grla-color-picker', GrlaColorPicker);
